/* eslint-disable camelcase */

const Logo = require('../assets/logo.png');

export const assets = {
	Logo,
};
